"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletManager = void 0;
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
var web3_js_1 = require("@solana/web3.js");
var index_1 = require("../connection/index");
var errors_1 = require("@hermis/errors");
/**
 * Manages wallet connections and interactions
 */
var WalletManager = /** @class */ (function () {
    /**
     * Creates a new WalletManager
     * @param network The Solana network to use (defaults to Mainnet)
     */
    function WalletManager(network) {
        if (network === void 0) { network = wallet_adapter_base_1.WalletAdapterNetwork.Mainnet; }
        this.network = network;
        this.wallet = null;
        this.connection = (0, index_1.createConnection)(network);
    }
    /**
     * Connects to a wallet adapter
     * @param wallet The wallet adapter to connect to
     * @returns A promise that resolves to a boolean indicating success
     */
    WalletManager.prototype.connect = function (wallet) {
        return __awaiter(this, void 0, Promise, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.wallet = wallet;
                        if (!!wallet.connected) return [3 /*break*/, 2];
                        return [4 /*yield*/, wallet.connect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, wallet.connected];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to connect wallet:', error_1);
                        this.wallet = null;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets the wallet's balance
     * @returns A promise that resolves to the wallet's balance in SOL
     */
    WalletManager.prototype.getBalance = function () {
        return __awaiter(this, void 0, Promise, function () {
            var balance, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.wallet || !this.wallet.publicKey) {
                            throw new errors_1.HermisError(errors_1.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED, {});
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.connection.getBalance(this.wallet.publicKey)];
                    case 2:
                        balance = _a.sent();
                        return [2 /*return*/, balance / web3_js_1.LAMPORTS_PER_SOL];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Failed to get balance:', error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets the wallet's public key
     * @returns The wallet's public key
     */
    WalletManager.prototype.getPublicKey = function () {
        if (!this.wallet || !this.wallet.publicKey) {
            throw new errors_1.HermisError(errors_1.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED, {});
        }
        return this.wallet.publicKey;
    };
    return WalletManager;
}());
exports.WalletManager = WalletManager;
